module.exports = __webpack_public_path__ + "img/twitter.058f19ff.svg";